export default __webpack_public_path__ + "static/media/cfx-painless.f5d97dcb.png";